/**
 * @Author: DKing
 * @Desc: 业务常量
 * @Date: 2019-07-22
 */

/**
 * pagination
 * 分页器配置参数
 * */
export const PAGINATION = {
  background: true,
  layout: "total, prev, pager, next, jumper"
};

/**
 * pc端菜单 - 慧用工
 * */
// 备案切换这里
export const PCMENUSLIST = [
  {
    name: "首页",
    className: "pc-nav-item pc-nav-item-active",
    path: "/index",
    displayMenus: false,
    isSubCategory: false,
    source: "sy"
  },
  {
    name: "产品服务",
    className: "pc-nav-item",
    path: "",
    displayMenus: false,
    isSubCategory: true,
    itemList: [
      {
        name: "灵活用工系统",
        nameTemp: "产品服务",
        path: "/prodServPc",
        className: "pc-nav-itemSon",
        source: "scpfw_lhyg"
      },
      {
        name: "慧用工",
        nameTemp: "产品服务",
        path: "/prodServH5",
        className: "pc-nav-itemSon",
        source: "cpfw_hyg"
      }
    ]
  },
  {
    name: "解决方案",
    className: "pc-nav-item",
    path: "",
    displayMenus: false,
    isSubCategory: true,
    itemList: [
      {
        name: "通用方案",
        path: "/solutionNormal",
        className: "pc-nav-itemSon",
        source: "jjfa_tyfa"
      },
      {
        name: "即时配送行业",
        path: "/solutionTimelyDist",
        className: "pc-nav-itemSon",
        source: "jjfa_jsps"
      },
      {
        name: "地产行业",
        path: "/solutionProperty",
        className: "pc-nav-itemSon",
        source: "jjfa_dchy"
      }
    ]
  },
  // {
  //   name:'资讯',
  //   displayMenus: false,
  //   isSubCategory: false,
  //   className:'pc-nav-item',
  //   path:'/newsAndInfo',
  //   source:'zx',
  // },
  {
    name: "关于我们",
    displayMenus: false,
    isSubCategory: false,
    className: "pc-nav-item",
    path: "/aboutUser",
    source: "gywm"
  }
];

/**
 * pc端菜单 - 衡阳慧用工
 * */
export const PCHYMENUSLIST = [
  {
    name: "招聘求职",
    className: "pc-nav-item",
    path: "",
    displayMenus: false,
    isSubCategory: true,
    itemList: [
      {
        name: "社会招聘",
        nameTemp: "招聘求职",
        path: "/jobRecruit",
        className: "pc-nav-itemSon",
        source: "zpqz_shzp"
      },
      {
        name: "发布求职",
        nameTemp: "招聘求职",
        path: "/jobPost",
        className: "pc-nav-itemSon",
        source: "zpqz_fbqz"
      }
    ]
  },
  {
    name: "衡阳慧用工",
    className: "pc-nav-item",
    path: "/index",
    displayMenus: false,
    isSubCategory: false,
    source: "sy"
  },
  {
    name: "产品服务",
    className: "pc-nav-item",
    path: "",
    displayMenus: false,
    isSubCategory: true,
    itemList: [
      {
        name: "灵活用工系统",
        nameTemp: "产品服务",
        path: "/prodServPc",
        className: "pc-nav-itemSon",
        source: "scpfw_lhyg"
      },
      {
        name: "慧用工",
        nameTemp: "产品服务",
        path: "/prodServH5",
        className: "pc-nav-itemSon",
        source: "cpfw_hyg"
      }
    ]
  },
  {
    name: "解决方案",
    className: "pc-nav-item",
    path: "",
    displayMenus: false,
    isSubCategory: true,
    itemList: [
      {
        name: "通用方案",
        path: "/solutionNormal",
        className: "pc-nav-itemSon",
        source: "jjfa_tyfa"
      },
      {
        name: "即时配送行业",
        path: "/solutionTimelyDist",
        className: "pc-nav-itemSon",
        source: "jjfa_jsps"
      },
      {
        name: "地产行业",
        path: "/solutionProperty",
        className: "pc-nav-itemSon",
        source: "jjfa_dchy"
      }
    ]
  },
  // {
  //   name:'资讯',
  //   displayMenus: false,
  //   isSubCategory: false,
  //   className:'pc-nav-item',
  //   path:'/newsAndInfo',
  //   source:'zx',
  // },
  {
    name: "关于我们",
    displayMenus: false,
    isSubCategory: false,
    className: "pc-nav-item",
    path: "/aboutUser",
    source: "gywm"
  }
];

/**
 * pc端
 * 首页 - 我们能为你做什么
 * */
export const WECANDOLIST = [
  {
    text: "成本控制",
    src: "../../../static/pc/indexPage/img_cbkz.png",
    isDisplay: false,
    desc:
      "对于企业而言，成本控制是使用灵活用工最重要原因之一，也是其基本性诉求，灵活用工模式可以有效降低企业的隐性成本。 "
  },
  {
    text: "用工质量",
    src: "../../../static/pc/indexPage/img_ygzl.png",
    isDisplay: false,
    desc:
      "在强竞争的市场局面下，任何行业的任何工作岗位，企业都更倾向于使用有经验的熟手，以带来更大的投入产出，提高单位时间的工作产 量。因此，灵活用工模式的用工质量更令企业满意。"
  },
  {
    text: "用工效率",
    src: "../../../static/pc/indexPage/img_ygxl.png",
    isDisplay: false,
    desc:
      "灵活用工模式有效解决了企业用工难、招工难的问题，同时提高了企业的招聘效率、上岗效率、组织效率、管理结算效率。"
  },
  {
    text: "风险控制",
    src: "../../../static/pc/indexPage/img_fxkz.png",
    isDisplay: false,
    desc:
      "灵活用工模式可以有效降低传统雇佣模式下的用工风险。但灵活用工模式下管理性和掌控性较弱，通过第三方平台认证注册制约、合同制约和管理制约可以有效提升。"
  }
];

/**
 * pc端
 * 首页 - 我们的服务行业
 * */
export const SERVICECONLIST = [
  {
    text: "即时配送",
    src: "../../../static/pc/indexPage/img_js2.png",
    className: "page-sec2-txt-active",
    classNameActive: "img-bg-active"
  },
  {
    text: "家政服务",
    src: "../../../static/pc/indexPage/img_jf2.png",
    className: "page-sec2-txt",
    classNameActive: "img-bg"
  },
  {
    text: "房产销售",
    src: "../../../static/pc/indexPage/img_fc1.png",
    className: "page-sec2-txt",
    classNameActive: "img-bg"
  },
  {
    text: "出行行业",
    src: "../../../static/pc/indexPage/img_cx1.png",
    className: "page-sec2-txt",
    classNameActive: "img-bg"
  },
  {
    text: "社区团购",
    src: "../../../static/pc/indexPage/img_st1.png",
    className: "page-sec2-txt",
    classNameActive: "img-bg"
  },
  {
    text: "在线教育",
    src: "../../../static/pc/indexPage/img_zj1.png",
    className: "page-sec2-txt",
    classNameActive: "img-bg"
  },
  {
    text: "文化传媒",
    src: "../../../static/pc/indexPage/img_wh1.png",
    className: "page-sec2-txt",
    classNameActive: "img-bg"
  },
  {
    text: "零售行业",
    src: "../../../static/pc/indexPage/img_ls1.png",
    className: "page-sec2-txt",
    classNameActive: "img-bg"
  }
];

/**
 * pc端
 * 首页 - bannar
 * */
export const BANNARCONLIST = [
  {
    title1: "场景化",
    title2: "灵活用工服务平台",
    desc:
      "慧用工基于云计算和大数据技术，构建了灵活用工行业的全流程数字化解决方案重构企业与人的用工关系，打造高效便捷、合作共赢的网络体系。",
    btnTxt: "免费体验",
    src: "../../../static/pc/indexPage/banner_home_1.png",
    bg: "../../../static/pc/indexPage/banner_home_bg1.png"
  },
  {
    title1: "慧用工灵活用工系统",
    title2: "通过等保三级认证",
    desc: "中华人民共和国公安部颁发：《信息系统安全等级保护备案证明》",
    btnTxt: "了解详情",
    src: "../../../static/pc/indexPage/banner_home_2.jpg",
    bg: "../../../static/pc/indexPage/banner_home_bg2.png"
  }
];
// extensionPage
/**
 * pc端
 * 特定推广页
 * */
export const BG_EXTENSION_LIST = [
  {
    src: "../../../static/pc/extensionPage/web_home_banner_1.png",
    bg: "../../../static/pc/extensionPage/bg_img_1.png"
  },
  {
    src: "../../../static/pc/extensionPage/web_home_banner_2.png",
    bg: "../../../static/pc/extensionPage/bg_img_2.png"
  }
];

/**
 * pc端
 * 共用 - foot
 * */
export const FOOT_CON_LIST = [
  {
    name: "首页",
    className: "pc-nav-item pc-nav-item-active",
    path: "/index",
    displayMenus: false,
    isSubCategory: false,
    itemList: [
      {
        title: "服务行业",
        id: "serviceTrade",
        source: "sy",
        path: "/index"
      },
      {
        title: "合作伙伴",
        id: "coopartner",
        path: "/index",
        source: "sy"
      },
      {
        title: "预约体验",
        id: "anchor",
        source: "sy",
        path: "/index"
      }
    ]
  },
  {
    name: "产品服务",
    className: "pc-nav-item",
    path: "",
    displayMenus: false,
    isSubCategory: true,
    itemList: [
      {
        title: "灵活用工系统",
        path: "/prodServPc",
        source: "cpfw_lhyg"
      },
      {
        title: "慧用工",
        path: "/prodServH5",
        source: "cpfw_hyg"
      }
    ]
  },
  {
    name: "解决方案",
    className: "pc-nav-item",
    path: "",
    displayMenus: false,
    isSubCategory: true,
    source: "",
    itemList: [
      {
        title: "通用方案",
        path: "/solutionNormal",
        source: "jjfa_tyfa"
      },
      {
        title: "即时配送行业",
        path: "/solutionTimelyDist",
        source: "jjfa_jsps"
      },
      {
        title: "地产行业",
        path: "/solutionProperty",
        source: "jjfa_dchy"
      }
    ]
  },
  // {
  //   name: "资讯",
  //   displayMenus: false,
  //   isSubCategory: false,
  //   className: "pc-nav-item",
  //   path: "/newsAndInfo",
  //   itemList: [
  //     {
  //       title: "新闻中心",
  //       path: "/newsAndInfo",
  //       source: "zx"
  //     }
  //   ]
  // },
  {
    name: "关于我们",
    displayMenus: false,
    isSubCategory: false,
    className: "pc-nav-item",
    path: "/aboutUser",
    itemList: [
      {
        title: "了解我们",
        id: 1,
        path: "/aboutUser",
        source: "gywm"
      },
      {
        title: "联系我们",
        id: 2,
        path: "/aboutUser",
        source: "gywm"
      },
      {
        title: "加入我们",
        id: 3,
        path: "/aboutUser",
        source: "gywm"
      }
    ]
  }
];

/**
 * pc端
 * 社会招聘 - 职位
 * */
export const POSILIST = [
  {
    posiTitle: "外卖配送",
    range: "全国｜性别不限｜学历不限",
    salary: "4000～10000元/月",
    experience: "经验不限",
    corporateName: "即时配招聘有限公司",
    phone: "135****2660",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent: "外卖配送员，公司配电动车，时间自由",
    serviceTime: "周一至周五，上午9:00—下午18:00",
    billingMode: "每单8-20元，多劳多得上不封顶"
  },
  {
    posiTitle: "装卸搬运",
    range: "天津市东丽区｜性别不限｜学历不限",
    salary: "面议",
    experience: "经验不限",
    corporateName: "劲有货运有限公司",
    phone: "176****9901",
    serviceLoca: "天津市东丽区",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent: "卸货服务，分包服务，装载服务",
    serviceTime: "周一至周日，每天上午8:00-下午18:00",
    billingMode: "每顿100-500元不等。按批次计费"
  },
  {
    posiTitle: "推广",
    range: "不限｜性别不限｜学历不限",
    salary: "1000-15000元/月",
    experience: "经验不限",
    corporateName: "京睿科技有限公司",
    phone: "189****4325",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent: "负责公司网站、公众号及线上活动进行推广，时间自由",
    serviceTime:
      "每周7天保证12小时电话及即时通讯工具沟通畅通，无固定时间要求，以拓展目标达成为主要标准",
    billingMode: "每单8-20元，多劳多得上不封顶"
  },
  {
    posiTitle: "专业设计",
    range: "不限｜性别不限｜学历不限",
    salary: "4000～10000元/月",
    experience: "经验不限",
    corporateName: "耀光城保服务有限公司",
    phone: "176****0923",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent:
      "利用CAD，proe等三维二维软件进行产品设计，bom表制作，生产跟踪，以及产品试装装配等工作",
    serviceTime: "9点至12点，13点至18点",
    billingMode: "20000+"
  },
  {
    posiTitle: "电路测试",
    range: "不限｜性别不限｜学历不限",
    salary: "面议",
    experience: "经验不限",
    corporateName: "新河物业有限公司",
    phone: "187****5550",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent: "按任务单要求完成指定任务",
    serviceTime: "8：00-18：00",
    billingMode: "每单8-20元，多劳多得上不封顶"
  },
  {
    posiTitle: "教练",
    range: "不限｜性别不限｜学历不限",
    salary: "5000～10000元/月",
    experience: "经验不限",
    corporateName: "乐刻健身有限公司",
    phone: "135****6689",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent:
      "1.具有专项运动的理论知识和较高的技术水平；2.掌握先进的教学和训练方法；3.具有全面设计、培训、引导与督促等能力",
    serviceTime: "早上九点到晚上11点",
    billingMode: "每日100-3500不等"
  },
  {
    posiTitle: "技术咨询",
    range: "不限｜性别不限｜学历不限",
    salary: "4000～10000元/月",
    experience: "经验不限",
    corporateName: "瑞祥科技服务有限公司",
    phone: "138****7729",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent:
      "按照公司要求采集汽车、保险行业数据。按时提交整理好的有效数据。数据采集过程不得使用非法手段。所有因此涉及的法律纠纷均有服务者自行承担责任。",
    serviceTime: "工作时间不限，但是必须按照公司的要求时间提交数据",
    billingMode: "每条数据10-100元不等"
  },
  {
    posiTitle: "市场推广",
    range: "不限｜性别不限｜学历不限",
    salary: "面议",
    experience: "经验不限",
    serviceLoca: "全国",
    corporateName: "众美国际有限公司",
    phone: "185****8821",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent:
      "1.对公司的软件、系统、技术服务等进行宣传推广；2.寻找意向客户，并尝试推进合作；3.协助公司进行客户维护以及签约合作",
    serviceTime: "法定工作日内根据自己时间自由安排",
    billingMode: "每条数据10-100元不等"
  },
  {
    posiTitle: "数据处理专员",
    range: "不限｜性别不限｜学历不限",
    salary: "4000～10000元/月",
    experience: "经验不限",
    corporateName: "开美天金融服务有限公司",
    phone: "176****0091",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent:
      "1、负责数据生产项目的数据处理工作；2、负责数据生产后期工作，主要负责模型精修；3、负责单数据软件市场调研及测试，为业务实施提供软件建议。",
    serviceTime: "没有限制具体工作时间，根据要求完成任务。",
    billingMode: "5000+ 根据处理数据量和数据质量结算"
  },
  {
    posiTitle: "翻译",
    range: "不限｜性别不限｜学历专科",
    salary: "4000～10000元/月",
    experience: "经验不限",
    corporateName: "瀚天教育有限公司",
    phone: "185****2633",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent:
      "负责客户委托的翻译稿，确保符合公司规定的翻译质量标准，确保按时、精准完成翻译工作",
    serviceTime: "随时接稿，要能处理紧急稿件",
    billingMode: "英译中：280元/千字；韩译中：350元/千字，其他语言价格可议"
  },
  {
    posiTitle: "软件测试",
    range: "北京｜性别不限｜学历专科",
    salary: "1000～20000元/月",
    experience: "经验不限",
    corporateName: "梦想加科技服务有限公司",
    phone: "135****4465",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent:
      "根据甲方要求为企业网站进行搭建测试跟维护并且进行测试维护，保证平台的平稳运行，及时发现并解决问题",
    serviceTime:
      "按照甲方要求完成具体项目，时间没有具体限制，按要求完成甲方项目",
    billingMode: "按初中高级别每人每小时115－322－688不等"
  },
  {
    posiTitle: "保洁",
    range: "不限｜性别不限｜学历不限",
    salary: "面议",
    experience: "经验不限",
    corporateName: "快净保洁服务有限公司",
    phone: "189****7768",
    serviceLoca: "全国",
    employmentCycle: "2022-01-01至2022-12-06",
    serviceContent: "路扫保洁员 班车接送 时间自由",
    serviceTime: "周一至周日 上午8:00-下午20:00 时间自由选择",
    billingMode: "1800+"
  }
];

/**
 * 移动端 - 导航
 * */
export const NAV_BUSSINESS_CONTS = [
  {
    title: "首页",
    children: [
      {
        title: "首页",
        path: "/mIndex"
      }
    ]
  },
  {
    title: "产品服务",
    children: [
      {
        title: "灵活用工系统",
        path: "/mProdServPc"
      },
      {
        title: "慧用工",
        path: "/mProdServH5"
      }
    ]
  },
  {
    title: "解决方案",
    children: [
      {
        title: "通用方案",
        path: "/mSolutionNormal"
      },
      {
        title: "即时配送行业",
        path: "/mSolutionTimelyDist"
      },
      {
        title: "地产行业",
        path: "/mSolutionProperty"
      }
    ]
  },
  // {
  //   title: "资讯",
  //   children: [
  //     {
  //       title: "新闻中心",
  //       path: "/mNewsAndInfo"
  //     }
  //   ]
  // },
  {
    title: "关于我们",
    children: [
      {
        title: "了解我们",
        path: "/mKnowUs"
      }
    ]
  }
];

/**
 * 移动端 - 首页 - 我们能做什么
 * */
export const BANNER_CAN_DO = [
  {
    src: "../../../static/mobile/index/img_ygcb.png",
    titleName: "成本控制",
    centent:
      "对于企业而言，成本控制是使用灵活用工最重要原因之一也是其基本性诉求，灵活用工模式可以有效降低企业的隐性成本。"
  },
  {
    src: "../../../static/mobile/index/img_ygzl.png",
    titleName: "用工质量",
    centent:
      "在强竞争的市场局面下，任何行业的任何工作 岗位，企业都更倾向于使用有经验的熟手，以带来更大的投入产出，提高单位时间的工作产量。因此，灵活用工模式的用工质量更令企业满意。"
  },
  {
    src: "../../../static/mobile/index/img_ygxl.png",
    titleName: "用工效率",
    centent:
      "灵活用工模式有效解决了企业用工难、招工难的问题，同时提高了企业的招聘效率、上岗效率、组织效率、管理结算效率。"
  },
  {
    src: "../../../static/mobile/index/img_fxkz.png",
    titleName: "风险控制",
    centent:
      "灵活用工模式可以有效降低传统雇佣模式下的用工风险，但灵活用工模式下管理性和掌控性 较弱，通过第三方平台认证注册制约、合同制 约和管理制约可以有效提升。"
  }
];

/**
 * 移动端 - 首页 - 我们的服务行业
 * */
export const BANNER_SERVICE = [
  { src: "./static/mobile/index/img_cxhy_shut.png", titleName: "出行行业" },
  { src: "./static/mobile/index/img_jsps_shut.png", titleName: "即时配送" },
  { src: "./static/mobile/index/img_zaixianjiaoyu.png", titleName: "在线教育" },
  { src: "./static/mobile/index/img_fcxs_shut.png", titleName: "房产销售" },
  { src: "./static/mobile/index/img_whcm_shut.png", titleName: "文化传媒" },
  { src: "./static/mobile/index/img_shequtuangou.png", titleName: "社区团购" },
  { src: "./static/mobile/index/img_lshy_shut.png", titleName: "零售行业" },
  { src: "./static/mobile/index/img_jiazhengfuwu.png", titleName: "家政服务" }
];

/**
 * pc端
 * 首页 & 移动端 - 地图
 * */
export const MAP_CON_LIST = [
  {
    number: 40,
    numberTemp: 40,
    text: "服务行业"
  },
  {
    number: 10000,
    numberTemp: 10000,
    text: "服务企业"
  },
  {
    number: 300,
    numberTemp: 300,
    text: "服务自由职业者"
  },
  {
    number: 300,
    numberTemp: 300,
    text: "服务结算金额"
  }
];

/**
 * 移动端 - 产品服务-灵活用功系统 - 产品优势
 * */
export const ADVANTAGE = [
  {
    src: "../../../static/mobile/mprodServPc/img_product_renwufabu.png",
    subtitleName: "任务发布",
    centent:
      "任务针对企业的业务场景，为企业提供标准化模版，帮助企业快速完成任务发布，并通过大数据分析精准匹配给平台上注册的自由职业者，同时完成在线签约。"
  },
  {
    src: "../../../static/mobile/mprodServPc/img_product_zhinengshenhe.png",
    subtitleName: "智能审核",
    centent:
      "自由职业者完成企业发布的任务后，平台会根据企业设定的审核标准在线智能审核。"
  },
  {
    src: "../../../static/mobile/mprodServPc/img_product_xinchoujiesuan.png",
    subtitleName: "薪酬结算",
    centent:
      "高效导入：企业可批量上传任务服务费结算单。秒级到账：实时对接银行系统，支持7*24小时结算下发，可下发至自由职业者个人银行账户、微信钱包账户、支付宝账户。专管账户：招商、网商银行专管账户，只能按企业命令进行下发，资金无挪用风险。"
  },
  {
    src: "../../../static/mobile/mprodServPc/img_product_kaifangjiekou.png",
    subtitleName: "开放接口",
    centent:
      "慧用工为企业提供API接口，为企业赋能，让企业能够将慧用工的服务融入自己的平台体系。"
  }
];

/**
 * 移动端 - 关于我们 - tabbar
 * */
export const ABOUT_US_TABBAR = [
  {
    icon: "../../static/mobile/aboutUs/icon_tab_liaojie_black.png",
    selectIcon: "../../static/mobile/aboutUs/icon_tab_liaojie_light.png",
    text: "了解我们",
    path: "/mKnowUs"
  },
  {
    icon: "../../static/mobile/aboutUs/icon_tab_lianxi_black.png",
    selectIcon: "../../static/mobile/aboutUs/icon_tab_lianxi_light.png",
    text: "联系我们",
    path: "/mContactUs"
  },
  {
    icon: "../../static/mobile/aboutUs/icon_tab_jiaru_black.png",
    selectIcon: "../../static/mobile/aboutUs/icon_tab_jiaru_light.png",
    text: "加入我们",
    path: "/mJoinUs"
  }
];

/**
 * 移动端 - 关于我们 - 轮播
 * */
export const ABOUT_US_BANNAR = [
  "2019年",
  "2020年",
  "2021年",
  "2022年",
  "2023年",
  "未来"
];

/**
 * 移动端 - 关于我们- 联系我们 - 办公地点
 * */
export const OFFICE_LOCATION = [
  {
    src: "../../static/mobile/aboutUs/aboutus_img_beijing.png",
    title: "北京｜总部",
    desc: "北京市朝阳区酒仙桥路甲12</br>号科技大厦4层"
  },
  {
    src: "../../static/mobile/aboutUs/aboutus_img_hainan.png",
    title: "海南 海口",
    desc: "海南省海口市美兰区</br>国瑞大厦写字楼B座西塔17楼1707房"
  },
  {
    src: "../../static/mobile/aboutUs/aboutus_img_jiangxi_g.png",
    title: "江西 共青城",
    desc: "江西省九江市共青城市</br>市民服务中心4号楼3层"
  },
  {
    src: "../../static/mobile/aboutUs/aboutus_img_shanghai.png",
    title: "上海",
    desc: "上海市长宁区金钟路</br>658弄17-2号东华大学国家</br>大学科技园17号楼"
  },
  {
    src: "../../static/mobile/aboutUs/aboutus_img_jiangxi_j.png",
    title: "江西 九江",
    desc: "江西九江市永修县</br>胡东新区开发大道铜锣湾广</br>场总部经济大楼"
  },
  {
    src: "../../static/mobile/aboutUs/aboutus_img_henyang.png",
    title: "湖南 衡阳",
    desc: "湖南省衡阳市珠晖区</br>衡州大道1号衡阳丽波国际</br>酒店3楼306房"
  },
  {
    src: "../../static/mobile/aboutUs/aboutus_img_zhuzhou.png",
    title: "湖南 株洲",
    desc: "湖南省株洲市醴陵市市民中</br>心三号楼五楼512室"
  },
  // {
  //   src: "../../static/mobile/aboutUs/aboutus_img_nanjing.png",
  //   title: "江苏 南京",
  //   desc: "江苏省南京市栖霞区云都会</br>大厦1幢1203室"
  // },
  {
    title: "浙江 杭州",
    src: "../../static/mobile/aboutUs/aboutus_img_hangzhou.png",
    desc: "浙江省杭州市滨江区滨康路</br>308号聚才大厦2507"
  },
  {
    title: "湖北 武汉",
    src: "../../static/mobile/aboutUs/aboutus_img_wuhan.png",
    desc: "湖北省武汉市双玺中心A座</br>1205室"
  },
  {
    title: "重庆",
    src: "../../static/mobile/aboutUs/aboutus_img_chongqing.png",
    desc: "重庆市观音桥协信中心<br>C座1301室"
  },
  {
    title: "广东 深圳",
    src: "../../static/mobile/aboutUs/aboutus_img_shenzhen.png",
    desc:
      "广东省深圳市龙华区龙华街</br>道东环二路8号中执时代广</br>场B座24楼2407"
  },
  {
    title: "广东 深圳",
    src: "../../static/mobile/aboutUs/aboutus_img_shenzhen_nan.png",
    desc: "广东省深圳市南山区大冲商</br>务中心（二期）1栋2号楼</br>（B座）2210"
  },
  {
    title: "江苏 淮安",
    src: "../../static/mobile/aboutUs/aboutus_img_huaian.png",
    desc: "江苏省淮安市清江浦区新亚</br>国际大厦1311室"
  },
  {
    title: "浙江 绍兴",
    src: "../../static/mobile/aboutUs/aboutus_img_shaoxing.png",
    desc: "浙江省绍兴市越城区迪荡街</br>道财智大厦1006"
  },
  {
    title: "广东 广州",
    src: "../../static/mobile/aboutUs/aboutus_img_guangzhou.png",
    desc: "广东省广州市番禺区汉溪大</br>道290号保利大都汇A3栋</br>1006单元"
  },
  {
    title: "广东 广州",
    src: "../../static/mobile/aboutUs/aboutus_img_guangzhou_huangpu.png",
    desc: "广东省广州市黄埔区黄埔大</br>道东850号906"
  },
  {
    title: "河南 周口",
    src: "../../static/mobile/aboutUs/aboutus_img_zhoukou.png",
    desc: "河南省周口市文昌大道东段</br>招商大厦615室"
  },
  {
    title: "湖南 长沙",
    src: "../../static/mobile/aboutUs/aboutus_img_changsha.png",
    desc: "湖南省长沙市芙蓉区五一大</br>道456号亚大时代2704房"
  },
  {
    title: "河南 郑州",
    src: "../../static/mobile/aboutUs/aboutus_img_zhengzhou.png",
    desc: "河南省郑州市管城回族区福禄路98号海赋国际大厦812室"
  },
  {
    title: "湖北 咸宁",
    src: "../../static/mobile/aboutUs/aboutus_img_xianning.png",
    desc: "湖北省咸宁市嘉鱼县鱼岳镇沙阳大道103号湖北嘉汇鑫数字经济产业园3楼"
  }
];

/**
 * 移动端 - 解决方案- 即时配送行业 - 慧用工方案优势
 * */

export const ADVANT_TAGEARRY = [
  {
    src: "../../../static/mobile/msolution/icon_solution_231.png",
    titleName: "组织结构优化",
    text:
      "帮助配送人员向个体工商户转型；助力企业人资组织结构优化，打造创新型新业态企业"
  },
  {
    src: "../../../static/mobile/msolution/icon_solution_32.png",
    titleName: "成本优化",
    text: "降低企业运营管理成本，降低企业用工成本，提高个人收入"
  },
  {
    src: "../../../static/mobile/msolution/icon_solution_233.png",
    titleName: "简单高效",
    text: "全线上化智能注册系统，两分钟完成线上注册，最快当天出营业执照"
  },
  {
    src: "../../../static/mobile/msolution/icon_solution_34.png",
    titleName: "资金安全",
    text:
      "我们与招商及网商银行建立合作，共管账户、专款专用、秒级结算到账（可结算至个人银行账户、微信钱包余额、支付宝账户）保障客户的资金安全"
  }
];

/**
 * 移动端 - 解决方案- 通用方案 - 慧用工方案优势
 * */

export const TONGYONG_TAGEARRY = [
  {
    src: "../../../static/mobile/msolution/icon_solution_31.png",
    titleName: "合法合规",
    text:
      "严格遵循国家法律法规，按规代征个人税收；平台业务链条完整合规，四流一致"
  },
  {
    src: "../../../static/mobile/msolution/icon_solution_32.png",
    titleName: "成本优化",
    text: "降低企业运营管理成本，降低企业用工成本，提高个人收入"
  },
  {
    src: "../../../static/mobile/msolution/icon_solution_233.png",
    titleName: "简单高效",
    text:
      "智能结算saas系统，全程线上办理，操作简单，提高企业管理效率，降低人工出错概率，降低HR及财务工作量"
  },
  {
    src: "../../../static/mobile/msolution/icon_solution_34.png",
    titleName: "资金安全",
    text:
      "我们与招商及网商银行建立合作，共管账户、专款专用秒级结算到账（可结算至个人银行账户、微信钱包余额、支付宝账户）保障客户的资金安全"
  }
];

/**
 * 移动端 - 关于我们- 加入我们
 * */

export const JOIN_US_CONST = [
  {
    title: "工程研发",
    src: "../../static/mobile/aboutUs/aboutus_icon_position.png",
    children: [
      {
        title: "运维工程师",
        desc:
          "岗位职责:<br>  1、负责服务器日常巡检工作，并根据提示修复漏洞和补丁； <br> 2、响应及解决同事的软件问题、网络要求、疑问以及系统使用过程中遇到的各种问题;<br>3、及时反馈技术处理过程中的异常情况，及时向部门负责人主动协调资源推动问题解决;<br> 4、阿里云产品采购、部署、排错以及后期的维护；" +
          "<br>5、维护钉钉后台oa流程，协助同事修改和新增流程；<br> 6、负责日常系统维护，及监控，提供IT软硬件方面的服务和支持，保证系统的稳定；<br><br>任职要求：<br>1、计算机软件或信息管理相关专业；<br> 2、有两年以上大型软硬件集成项目实施或项目管理经验者优先；<br> 3、熟悉vmware vcenter操作环境；熟悉Linux常用命令操作，熟悉Oracle数据库，NFS，Nginx，RabbitMQ 、Eureka等常用组件有容器环境、PaaS运维经验优先考虑；" +
          "<br>4、具备较强的表达、沟通、协调、组织能力，具有很强执行力、团队意识，积极主动完成各项工作；<br> 5、较强的学习能力，具备较好的项目总结、汇报及业务成果提炼和推广经验；",
        name: "1"
      }
    ]
  },
  {
    title: "市场&销售",
    src: "../../static/mobile/aboutUs/aboutus_icon_position.png",
    children: [
      {
        title: "渠道合伙人",
        desc:
          "岗位职责:<br>  1、负责慧用工(灵活用工）平台在当地各领域的拓展及客户资源挖掘; <br>2、负责各行业头部企业战略客户开发、商务谈判工作，完成销售目标;<br>3、独立完成各种综合性、整合性业务的商务沟通工作;<br> 4、思维敏捷、逻辑性强，有较强的学习和执行能力;" +
          "<br><br>任职要求:<br>1、除金融、保险、医疗行业以外，有1~2个行业内头部企业资源(有合作过，与关键决策人或财务负责人有良好的人脉关系);<br> 2、在头部企业内任职过中层（总监及以上）业务管理经验，单个公司服务时长不得低于5年；<br>3、或有投行投资经理岗位5年以上工作经验； <br>4、长江、中欧、北大光华、湖畔等商学院辅导员5年以上工作经验；" +
          "<br><br>招募说明:<br>1、有想法不甘于现状，对税务筹划-灵活用工有所了解，并且对这个赛道感兴趣，有丰富的各行头部企业人脉和资源，可以快速在当地启动项目并落地；<br> 2、有强烈的目标意识，熟悉商务谈判流程，有驾驭全局整合资源的能力；<br> 3、总部提供强有力的专业支持，运营团队支持；<br>4、无需坐班，只需要每周参加1次会议； 欢迎您的加入！",
        name: "2"
      },

      {
        title: "政府关系",
        desc:
          "岗位职责:<br> 1、组织协调来访接待及考察相关外联工；<br>2、做好与相关政府部门的沟通和联络工作，保持与政府相关部门的良好互动及合作关系；<br>3、了解行业动态和相关产业的政策，搜集有价值的行业信息及政策信息；<br>4、参与政府会议、行业活动，协助公司重要来宾参观、接待和管理工作；" +
          "<br>5、根据项目推进情况，撰写政府申请报告、汇报文件等各类公函；<br>6、根据项目落地情况，协助制作并编写产品方案PPT；<br>7、完成部门职责所需的其他相关工作；<br><br>基础要求：<br>1、年龄要求：25—40岁 <br>2、学历要求：大专及以上；" +
          "<br><br>任职要求：<br>1、熟悉政府关系维护，具备一定的政府关系处理能力<br>2、具有优秀的公告关系处理技能，会应酬能喝酒； <br>3、具有很强的协调、社会活动、语言文字、业务实施能力；<br>4、了解产业园区、政府各部门的关系及常规业务模式；<br>5、适应出差，适应加班，能协调好家庭与工作关系；",
        name: "3"
      },

      {
        title: "营销总监（北京）",
        desc:
          "岗位职责:<br> 1、负责确立运营管理方针、发展方向，组织框架及长期产品运营规划谋划；<br>2、熟悉先进的营销方法，对市场战略规划、市场开拓、市场管理、终端客户维护及品牌建设上有丰富的经验；<br>3、对市场具有敏锐的感知力，能及时感知产品的市场动态和市场方向；<br>4、负责公司产品服务品质监控，顾客满意度管理；<br>5、负责产品重大营销活动策划和决策，并对结果负责；" +
          "<br><br>任职要求：<br>1、5年及以上一物一码数字化营销行业及相关工作经验；<br>2、熟悉先进的营销方法，对市场战略规划、市场开拓、市场管理、终端客户维护及品牌建设上有丰富的经验； <br>3、对市场具有敏锐的感知力，能及时感知产品的市场动态和市场方向；<br>4、有有效的团队管理能力和组织协调能力；<br>5、具有强烈的责任心、事业心，抗压能力强，敢于接受挑战；6、熟悉快消品行业、私域流量运营；",
        name: "4"
      },
      {
        title: "大客户销售经理（北京）",
        desc:
          "岗位职责：<br>1、负责开发和拓展大中型企业单位等客户，达成商业合作；<br>2、分析、挖掘客户需求，为客户提供专业的财务税务优化解决方案；<br>3、管理维护客户间的长期战略合作计划，对客户需求进行深度挖掘，达成深度合作，提升销售业绩；<br>4、负责销售项目管理，包括项目跟踪、谈判、签约、收款、客户关系的维护等一系列销售活动；<br>5、提高客户满意度；定期拜访和维系重点客户；<br>6、负责销售区域内客户信息收集；行业信息收集等；" +
          "<br><br>职位待遇：<br>1、优厚的薪金，周末双休+五险一金+业绩提成；<br>2、丰富多彩的员工活动：员工聚餐、年度体检、节日晚会、旅游活动、优秀员工表彰活动等；<br>3、多元化培训课程：带薪岗前业务培训，在职个人提升计划；<br>4、良好晋升机会：内部转职（横向发展）、纵向提升；",
        name: "5"
      }
    ]
  }
];

/**
 * 移动端 - 解决方案- 房地产行业
 * */
export const OUR_ADVANTAGE = [
  {
    titleName: "营销赋能",
    txt1: "项目地域所在地私域流量传播-饱和式覆盖所有人群",
    txt2: "完全可视化营销费用支出-精确到人的树状传播结构",
    txt3: "企业自己的销售渠道-企业能完全掌控",
    txt4: "全民营销平台下的个人分佣比例最大"
  },
  {
    titleName: "合法合规",
    txt1:
      "严格遵循国家法律法规，按 规代征个人税收；平台业务链条完整合规，四流一致-饱和式覆盖所有人群"
  },
  {
    titleName: "成本优化",
    txt1:
      "降低企业运营管理成本，降低企业雇佣模式下用工风险及成本，提高个人收入-饱和式覆盖所有人群"
  },
  {
    titleName: "简单高效",
    txt1:
      "智能结算saas系统，全程线上办理，操作简单，提高企业管理效率，降低人工出错概率，降低HR及财务工作量"
  },
  {
    titleName: "资金安全",
    txt1:
      "我们与招商及网商银行建立合作，共管账户、专款专用、秒级结算到账（可结算至个人银行账户、微信钱包余额、支付宝账户），保障客户的资金安全"
  }
];

// pc 端 - 关于我们 - tab
export const PC_ABOUT_TAB_LIST = [
  // tab列表
  {
    id: "1",
    tabName: "了解我们",
    imgUrl: "../../../static/pc/about/icon_tab_liaojie_light@2x.png",
    className: "tab-item active"
  },
  {
    id: "2",
    tabName: "联系我们",
    imgUrl: "../../../static/pc/about/icon_tab_lianxi_black@2x.png",
    className: "tab-item"
  },
  {
    id: "3",
    tabName: "加入我们",
    imgUrl: "../../../static/pc/about/icon_tab_jiaru_black@2x.png",
    className: "tab-item"
  }
];

// pc 端 - 关于我们 - 发展历程
export const PC_ABOUT_HISTORY_LIST = [
  // 发展历程列表
  {
    id: "1",
    year: "2019",
    isActive: false,
    className: "time-point ",
    list: [
      { monthText: "2月", content: "海南慧用工服务有限公司注册成立" },
      { monthText: "4月", content: "慧用工1.0系统上线，并试运营" },
      { monthText: "9月", content: "慧用工2.0系统上线，且单月发薪额过亿元" },
      { monthText: "12月", content: "运行9个月时间，累计交易额突破10亿元" }
    ]
  },
  {
    id: "2",
    year: "2020",
    isActive: false,
    className: "time-point",
    list: [
      {
        monthText: "5月",
        content: "慧用工被海南省税务局评为《灵活用工平台标杆企业》"
      },
      {
        monthText: "6月",
        content: "建立江西共青城分部，个体户集群注册产品上线"
      },
      { monthText: "11月", content: "建立江西永修分部" },
      {
        monthText: "12月",
        content:
          "搭建新业态、金融、地产、即配等垂直行业事业部，强化垂直行业个性化服务质量"
      }
    ]
  },
  {
    id: "3",
    year: "2021",
    isActive: false,
    className: "time-point",
    list: [
      { monthText: "3月", content: "衡阳慧用工分公司成立" },
      { monthText: "5月", content: "湖南慧用工分公司成立" },
      { monthText: "5月", content: "慧用工获企业信用AAA证书" },
      {
        monthText: "10月",
        content: "湖南慧用工获“2021年度中国区最佳人力资本服务”企业奖"
      },
      { monthText: "12月", content: "交易额过80亿，服务灵活就业者超100万" }
    ]
  },
  {
    id: "4",
    year: "2022",
    isActive: true,
    className: "time-point active-point-time",
    list: [
      { monthText: "3月", content: "湖南慧用工科技集团有限公司成立" },
      { monthText: "4月", content: "湖南慧用工北京分公司成立" },
      { monthText: "6月", content: "湖南慧用工上海分公司成立" },
      { monthText: "9月", content: "慧用工招聘团队成立" },
      { monthText: "12月", content: "交易额过200亿+，服务灵活就业者超200万+" }
    ]
  },
  {
    id: "5",
    year: "2023",
    isActive: false,
    className: "time-point",
    list: [
      { monthText: "1月", content: "河南慧用工分公司成立" },
      { monthText: "3月", content: "慧用工招聘月交付到岗人数突破1000人" },
      { monthText: "3月", content: "华中大区在武汉成立" },
      { monthText: "4月", content: "慧用工获美团新锐服务商奖项" },
      { monthText: "5月", content: "华南地区在广东成立" },
      { monthText: "10月", content: "慧用工累计交易额突破300亿" },
      { monthText: "12月", content: "咸宁慧用工分公司成立" }
    ]
  },
  {
    id: "6",
    year: "未来",
    isActive: false,
    className: "time-point",
    list: []
  }
];

// pc 端 - 关于我们 - 办公地址
export const PC_ABOUT_ADDRESS_LIST = [
  // 办公地点列表
  {
    city: "北京 ｜ 总部",
    imgUrl: "../../../static/pc/about/aboutus_img_beijing.png",
    addrDetail: "北京市朝阳区酒仙桥路甲12\n号科技大厦4层"
  },
  {
    city: "海南 海口",
    imgUrl: "../../../static/pc/about/aboutus_img_hainan.png",

    addrDetail: "海南省海口市美兰区\n国瑞大厦写字楼B座西塔\n17楼1707房"
  },

  {
    city: "江西 共青城",
    imgUrl: "../../../static/pc/about/aboutus_img_jiangxi_g.png",
    addrDetail: "江西省九江市共青城市\n市民服务中心4号楼3层"
  },
  {
    city: "上海",
    imgUrl: "../../../static/pc/about/aboutus_img_shanghai.png",
    addrDetail: "上海市长宁区金钟路\n658弄17-2号东华大学国家\n大学科技园17号楼"
  },
  {
    city: "江西 九江",
    imgUrl: "../../../static/pc/about/aboutus_img_jiangxi_j.png",
    addrDetail: "江西九江市永修县\n胡东新区开发大道铜锣湾广\n场总部经济大楼"
  },
  {
    city: "湖南 衡阳",
    imgUrl: "../../../static/pc/about/aboutus_img_hunan_h.png",
    addrDetail: "湖南省衡阳市珠晖区\n衡州大道1号衡阳丽波国际酒\n店3楼306房"
  },
  {
    city: "湖南 株洲",
    imgUrl: "../../../static/pc/about/aboutus_img_liling.png",
    addrDetail: "湖南省株洲市醴陵市市民\n中心三号楼五楼512室"
  },
  // {
  //   city: "江苏 南京",
  //   imgUrl: "../../../static/pc/about/aboutus_img_nanjing.png",
  //   addrDetail: "江苏省南京市栖霞区云都会\n大厦1幢1203室"
  // },
  {
    city: "浙江 杭州",
    imgUrl: "../../../static/pc/about/aboutus_img_zhejiang.png",
    addrDetail: "浙江省杭州市滨江区滨康路\n308号聚才大厦2507"
  },
  {
    city: "湖北 武汉",
    imgUrl: "../../../static/pc/about/aboutus_img_wuhan.png",
    addrDetail: "湖北省武汉市双玺中心A座\n1205室"
  },
  {
    city: "重庆",
    imgUrl: "../../../static/pc/about/aboutus_img_chongqing.png",
    addrDetail: "重庆市观音桥协信中心\nC座1301室"
  },
  {
    city: "广东 深圳",
    imgUrl: "../../../static/pc/about/aboutus_img_shenzhen.png",
    addrDetail:
      "广东省深圳市龙华区龙华街\n道东环二路8号中执时代广\n场B座24楼2407"
  },
  {
    city: "广东 深圳",
    imgUrl: "../../../static/pc/about/aboutus_img_shenzhen_n.png",
    addrDetail: "广东省深圳市南山区大冲商\n务中心（二期）1栋2号楼\n（B座）2210"
  },
  {
    city: "江苏 淮安",
    imgUrl: "../../../static/pc/about/aboutus_img_huaian.png",
    addrDetail: "江苏省淮安市清江浦区新亚\n国际大厦1311室"
  },
  {
    city: "浙江 绍兴",
    imgUrl: "../../../static/pc/about/aboutus_img_shaoxing.png",
    addrDetail: "浙江省绍兴市越城区迪荡街\n道财智大厦1006"
  },
  {
    city: "广东 广州",
    imgUrl: "../../../static/pc/about/aboutus_img_guangzhou_f.png",
    addrDetail: "广东省广州市番禺区汉溪大\n道290号保利大都汇A3栋\n1006单元"
  },
  {
    city: "广东 广州",
    imgUrl: "../../../static/pc/about/aboutus_img_guangzhou.png",
    addrDetail: "广东省广州市黄埔区黄埔大\n道东850号906"
  },
  {
    city: "河南 周口",
    imgUrl: "../../../static/pc/about/aboutus_img_zhoukou.png",
    addrDetail: "河南省周口市文昌大道东段\n招商大厦615室"
  },
  {
    city: "湖南 长沙",
    imgUrl: "../../../static/pc/about/aboutus_img_changsha.png",
    addrDetail: "湖南省长沙市芙蓉区五一大\n道456号亚大时代2704房"
  },
  {
    city: "湖北 咸宁",
    imgUrl: "../../../static/pc/about/aboutus_img_xianning.png",
    addrDetail:
      "湖北省咸宁市嘉鱼县鱼岳镇沙阳大道103号湖北嘉汇鑫数字经济产业园3楼"
  },
  {
    city: "河南 郑州",
    imgUrl: "../../../static/pc/about/aboutus_img_zhengzhou.png",
    addrDetail: "河南省郑州市管城回族区福禄路98号海赋国际大厦812室"
  }
];

// pc 端 - 关于我们 - 开发职位
export const PC_ABOUT_DEV_POSTS_LIST = [
  // 研发职位列表
  {
    id: "1",
    isOpen: false,
    isDeliver: false,
    postName: "运维工程师",
    postDesc:
      "职位描述：\n1、负责服务器日常巡检工作，并根据提示修复漏洞和补丁；\n2、响应及解决同事的软件问题、网络要求、疑问以及系统使用过程中遇到的各种问题；\n3、及时反馈技术处理过程中的异常情况，及时向部门负责人主动协调资源推动问题解决;" +
      "\n4、阿里云产品采购、部署、排错以及后期的维护；\n5、维护钉钉后台oa流程，协助同事修改和新增流程；\n6、负责日常系统维护，及监控，提供IT软硬件方面的服务和支持，保证系统的稳定；",
    postRequire:
      "任职要求：\n1、计算机软件或信息管理相关专业；\n2、有两年以上大型软硬件集成项目实施或项目管理经验者优先；\n3、熟悉 vmware vcenter操作环境；熟悉Linux常用命令操作，熟悉Oracle数据库，NFS，Nginx，RabbitMQ 、Eureka等常用组件有容器环境、PaaS运维经验优先考虑；\n4、具备较强的表达、沟通、协调、组织能力，具有很强执行力、团队意识，积极主动完成各项工作；" +
      "\n5、较强的学习能力，具备较好的项目总结、汇报及业务成果提炼和推广经验；"
  }
];

// pc 端 - 关于我们 - 市场职位
export const PC_ABOUT_MARKET_POSTS_LIST = [
  // 市场&销售岗位列表
  {
    id: "1",
    isOpen: false,
    isDeliver: false,
    postName: "营销总监（北京）",
    postDesc:
      "职位描述：\n1、负责确立运营管理方针、发展方向，组织框架及长期产品运营规划谋划；\n2、参与公司产品决策，协助总经理进行产品战略方向决策；\n3、负责运营团队的管理和搭建，建立健全的管理制度，提高运营工作效率；\n4、负责公司产品服务品质监控，顾客满意度管理；\n5、负责产品重大营销活动策划和决策，并对结果负责；",
    postRequire:
      "职位要求：\n1、5年及以上一物一码数字化营销行业及相关工作经验；\n2、熟悉先进的营销方法，对市场战略规划、市场开拓、市场管理、终端客户维护及品牌建设上有丰富的经验；\n3、对市场具有敏锐的感知力，能及时感知产品的市场动态和市场方向；\n4、有有效的团队管理能力和组织协调能力；\n5、具有强烈的责任心、事业心，抗压能力强，敢于接受挑战；\n6、熟悉快消品行业、私域流量运营；"
  },
  {
    id: "2",
    isOpen: false,
    isDeliver: false,
    postName: "大客户销售经理（北京）",
    postDesc:
      "岗位职责：\n1、负责开发和拓展大中型企业单位等客户，达成商业合作；\n2、分析、挖掘客户需求，为客户提供专业的财务税务优化解决方案；\n3、管理维护客户间的长期战略合作计划，对客户需求进行深度挖掘，达成深度合作，提升销售业绩；\n4、负责销售项目管理，包括项目跟踪、谈判、签约、收款、客户关系的维护等一系列销售活动；\n5、提高客户满意度；定期拜访和维系重点客户；\n6、负责销售区域内客户信息收集；行业信息收集等；",
    postRequire:
      "职位待遇：\n1、优厚的薪金，周末双休+五险一金+业绩提成；\n2、丰富多彩的员工活动：员工聚餐、年度体检、节日晚会、旅游活动、优秀员工表彰活动等；\n3、多元化培训课程：带薪岗前业务培训，在职个人提升计划；\n4、良好晋升机会：内部转职（横向发展）、纵向提升；"
  },
  {
    id: "3",
    isOpen: false,
    isDeliver: false,
    postName: "渠道合伙人",
    postDesc:
      "岗位职责：\n1、负责慧用工(灵活用工）平台在当地各领域的拓展及客户资源挖掘；\n2、负责各行业头部企业战略客户开发、商务谈判工作，完成销售目标；\n3、独立完成各种综合性、整合性业务的商务沟通工作；\n4、思维敏捷、逻辑性强，有较强的学习和执行能力；",
    postRequire:
      "职位待遇：\n1、除金融、保险、医疗行业以外，有1~2个行业内头部企业资源（有合作过，与关键决策人或财务负责人有良好的人脉关系）； \n2、在头部企业内任职过中层（总监及以上）业务管理经验，单个公司服务时长不得低于5年； \n3、或有投行投资经理岗位5年以上工作经验； \n4、长江、中欧、北大光华、湖畔等商学院辅导员5年以上工作经验； \n\n招募说明： \n1、有想法不甘于现状，对税务筹划-灵活用工有所了解，并且对这个赛道感兴趣，有丰富的各行头部企业人脉和资源，可以快速在当地启动项目并落地； \n2、有强烈的目标意识，熟悉商务谈判流程，有驾驭全局、整合资源的能力； \n3、总部提供强有力的专业支持，运营团队支持； \n4、无需坐班，只需要每周参加1次会议； 欢迎您的加入！"
  },
  {
    id: "4",
    isOpen: false,
    isDeliver: false,
    postName: "政府关系",
    postDesc:
      "工作职责：\n1、组织协调来访接待及考察相关外联工作； \n2、做好与相关政府部门的沟通和联络工作，保持与政府相关部门的良好互动及合作关； \n3、了解行业动态和相关产业的政策，搜集有价值的行业信息及政策信息；\n4、参与政府会议、行业活动，协助公司重要来宾参观、接待和管理工作； \n5、根据项目推进情况，撰写政府申请报告、汇报文件等各类公函；\n6、根据项目落地情况，协助制作并编写产品方案PPT；" +
      "\n7、完成部门职责所需的其他相关工作； \n\n基础要求：\n1、年龄要求：25—40岁； \n2、学历要求：大专及以上；",
    postRequire:
      "任职要求：\n1、熟悉政府关系维护，具备一定的政府关系处理能力；\n2、具有优秀的公告关系处理技能，会应酬能喝酒；\n3、具有很强的协调、社会活动、语言文字、业务实施能力；\n4、了解产业园区、政府各部门的关系及常规业务模式；\n5、适应出差，适应加班，能协调好家庭与工作关系；"
  }
];



// WEBPACK FOOTER //
// ./src/service/businessConsts.js